// Based on: https://goulet.dev/posts/error-serialization-in-js/

export const isErrorLike = (
  // Have to use <any> here as otherwise the TypeScript version used in app throws an error - this is not needed on the-nest or AP
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  error: any
): error is Record<string, unknown> & { message: string } => {
  return (
    typeof error === 'object' &&
    error !== null &&
    'message' in error &&
    typeof error.message === 'string'
  );
};

export const toError = (error: unknown): Error => {
  // Regular Error object
  if (typeof error === 'object' && error instanceof Error) {
    return error;
  }

  // string
  if (typeof error === 'string') {
    return new Error(error);
  }

  // Error-like object
  if (isErrorLike(error)) {
    const newError = new Error(error.message);

    if ('name' in error && typeof error.name === 'string') {
      newError.name = error.name;
    }

    return newError;
  }

  // Something else
  return new Error(JSON.stringify(error));
};
